module.exports = __webpack_public_path__ + "img/awards_image_06.3ea15f53.jpg";